<div
  [ngClass]="{
    'page-container': true,
    'remove-padding': container.removePadding,
    'shui-page-container': style === 'shui',
  }"
>
  @if (!container.removePadding) {
    <header class="mobile-header">
      <nav id="mobile-header">
        @if (container.goBackBtn) {
          <button (click)="container.goBackFunction()">
            <img src="/assets/icons/arrow_back.svg" />
          </button>
        } @else {
          <div></div>
        }
        <h1
          class="mobile-title"
          (click)="container.onTitleClick()"
        >
          {{ translation.getTranslation(container.titleSignal()) }}
        </h1>
        @if (container.mobileMenu) {
          <button (click)="openDrawer()">
            <img src="/assets/icons/menu.svg" />
          </button>
        }
      </nav>
    </header>
  }
  <main
    class="page-content"
    [ngClass]="{
      'has-padding': !container.removePadding,
    }"
  >
    <header
      class="page-header"
      *ngIf="container.showHeader"
    >
      <div class="flex row gap-075 items-center">
        @if (container.icon) {
          <span class="material-symbols-outlined icon">{{ container.icon }}</span>
        }
        <h1
          class="title"
          [ngClass]="{
            'color-shui': styleThemeService.currentTheme === 'shui',
            'color-otimus': styleThemeService.currentTheme !== 'shui',
          }"
          (click)="container.onTitleClick()"
        >
          {{ translation.getTranslation(container.titleSignal()) }}
        </h1>
        @if (effectiveBreadcrumb().length > 0) {
          <oc-breadcrumb
            class="page-breadcrumb"
            [ocItems]="effectiveBreadcrumb()"
          />
        }
      </div>
      <div class="flex justify-between gap-075">
        <ng-container
          *ngIf="buttonTemplate$ | async as tpl"
          [ngTemplateOutlet]="tpl"
        ></ng-container>
      </div>
    </header>
    <section class="content">
      <ng-content></ng-content>
      <router-outlet></router-outlet>
    </section>
  </main>

  <app-drawer
    [open]="drawerOpen"
    (onClose)="closeDrawer()"
  ></app-drawer>

  <!-- Easter egg overlay -->
  <div
    class="easter-egg-overlay"
    *ngIf="container.easterEggVisible"
    (click)="container.hideEasterEgg()"
  >
    <div
      class="easter-egg-content"
      (click)="$event.stopPropagation()"
    >
      <video
        class="easter-egg-video"
        src="/assets/easter-eggs/guitar.webm"
        autoplay
        muted
        playsinline
        (ended)="container.hideEasterEgg()"
      ></video>
      <div class="easter-egg-caption">
        <p class="caption-main">Me gusta el sushi, tocando la guitarra</p>
        <small class="caption-secondary">EasterEgg</small>
      </div>
    </div>
  </div>
</div>
